import { Button, Form, Select, message } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { BASE_API_URL } from "../../../utils/consts";
import { useEffect, useState } from "react";
import { useAuth } from "../../../utils/useAuth";

const { Option } = Select;

const SuperAdminPermissions = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const authUser: any = useAuth();
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // --- Fetch all users for dropdown ---
  useEffect(() => {
    if (!authUser?.clientId) return;

    axios
      .get(`${BASE_API_URL}/${authUser.clientId}/users`)
      .then((res) => setUsers(res.data))
      .catch(() => message.error(t("Failed to load users")));
  }, [authUser?.clientId, t]);

  // --- Submit handler ---
  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await axios.put(`${BASE_API_URL}/user/addRole/${values.userId}`, {
        roles: values.roles, // <-- sad šaljemo niz
      });
      message.success(t("Roles successfully updated"));
      form.resetFields();
    } catch (err) {
      message.error(t("Error updating roles"));
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settingsTab">
      <div className="settingsForm">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: 400 }}
        >
          {/* USER SELECT */}
          <Form.Item
            label={t("Select User")}
            name="userId"
            rules={[{ required: true, message: t("Please select a user") }]}
          >
            <Select
              showSearch
              placeholder={t("Select user")}
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                (option?.children as string)
                  ?.toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {users.map((user) => (
                <Option key={user._id} value={user._id}>
                  {`${user.fullName || ""} (${user.email})`}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* MULTIPLE ROLE SELECT */}
          <Form.Item
            label={t("Assign Roles")}
            name="roles"
            rules={[
              { required: true, message: t("Please select at least one role") },
            ]}
          >
            <Select
              mode="multiple"
              placeholder={t("Select one or more roles")}
              allowClear
            >
              <Option value="superadmin">{t("Superadmin")}</Option>
              <Option value="admin">{t("Admin")}</Option>
              <Option value="moderator">{t("Moderator")}</Option>
              <Option value="user">{t("User")}</Option>
            </Select>
          </Form.Item>

          {/* SAVE BUTTON */}
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              {t("Save")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SuperAdminPermissions;
